import {
  type IAdditionalColors,
  globalStyleDefault,
} from '../../../../constants/GlobalStyles';
import { type ITemplateColors } from '../../../../services/courses';

export const generateOldNewColors = (colors: IAdditionalColors) => {
  const colorsArray = Object.values(colors);
  return colorsArray.map((color) => ({ color }));
};

export const generateOldNewTemplateColors = (
  templateColors: ITemplateColors
): ITemplateColors => ({
  primaryColor: templateColors.primaryColor ?? '',
  secondaryColor: templateColors.secondaryColor ?? '',
  backgroundColor: templateColors.backgroundColor ?? '',
  accentColor: templateColors.accentColor ?? '',
});

export const generateOldNewAdditionalColors = (
  additionalColors: IAdditionalColors
): Array<{ color: string }> => {
  return generateOldNewColors(additionalColors);
};

export const generateTemplateColorsToUpdate = (
  templateColors: Partial<ITemplateColors>
): ITemplateColors => {
  return {
    primaryColor:
      templateColors.primaryColor ??
      globalStyleDefault.templateColors.primaryColor,
    secondaryColor:
      templateColors.secondaryColor ??
      globalStyleDefault.templateColors.secondaryColor,
    backgroundColor:
      templateColors.backgroundColor ??
      globalStyleDefault.templateColors.backgroundColor,
    accentColor:
      templateColors.accentColor ??
      globalStyleDefault.templateColors.accentColor,
  };
};

export const generateAdditionalColorsToUpdate = (
  oldAdditionalColors: IAdditionalColors,
  additionalColors: Array<{ color?: string } | undefined>
): IAdditionalColors => {
  const newAdditionalColors: Record<string, string> = {};
  const oldObjAdditionalColors = Object.values(oldAdditionalColors ?? {});
  oldObjAdditionalColors.forEach((oldColorObj, idx) => {
    const newColor = additionalColors[idx]?.color;
    if (newColor) {
      newAdditionalColors[oldColorObj] = newColor;
    }
  });
  return newAdditionalColors;
};
